import React from "react";
import { getCategoryMeta, getSubCategoryIcon } from "../../constants/categoryMeta";
import {
  labelForCategory,
  labelForSubCategory,
} from "../../constants/reconciliationLabels";

/**
 * The "Type" cell: a colour-coded category pill, with the sub-category and its icon
 * beneath it.
 *
 * Shared by the Task Library and the Results Dashboard so the two tables read as one
 * product. Extracted rather than copied — the previous duplication of a connection form
 * in this codebase drifted into two different payloads, and a pill with two colour maps
 * would go the same way.
 *
 * The sub-line is omitted entirely when there is no meaningful sub-category. Master Suite
 * results store "N/A" for both fields, and printing that literally reads as missing data,
 * so the caller passes no subCategory and the pill stands alone.
 */
function CategoryTypeCell({ category, subCategory }) {
  const meta = getCategoryMeta(category);
  return (
    <div className="arc-type-cell">
      <span className="arc-type-pill" style={{ backgroundColor: meta.color }}>
        {labelForCategory(meta.label)}
      </span>
      {subCategory && (
        <span className="arc-type-sub">
          {getSubCategoryIcon(subCategory)}
          {labelForSubCategory(subCategory)}
        </span>
      )}
    </div>
  );
}

export default CategoryTypeCell;
